// function getRandomColor() {
//   var letters = "0123456789ABCDEF";
//   var color = "#";
//   for (var i = 0; i < 6; i++) {
//     color += letters[Math.floor(Math.random() * 16)];
//   }
//   return color;
// }

export function getRandomColor() {
    const colors = ["#ff5733", "#33ff57", "#5733ff", "#ff33f6", "#33f6ff", "#FFD700", "#0000FF", "#9400D3"];
    const randomIndex = Math.floor(Math.random() * colors.length);
    return colors[randomIndex];
  }
  